module.exports = __webpack_public_path__ + "img/locatie-icon.b2046af9a67a5262b1da31383d4c1bc1.svg";